var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},[_vm._l((_vm.data),function(item,i){return _c('image-swiper',{key:i,staticClass:"block",attrs:{"swiper-id":('pro1' + i),"project":item}})}),_c('concat-panel')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }